import { render, staticRenderFns } from "./SetupInfo.vue?vue&type=template&id=3db57c5c"
import script from "./SetupInfo.vue?vue&type=script&lang=js"
export * from "./SetupInfo.vue?vue&type=script&lang=js"
import style0 from "./SetupInfo.vue?vue&type=style&index=0&id=3db57c5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports